<script setup lang="ts">
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ProgressFrame from './layout/ProgressFrame.vue';
import ScanQRCodeButton from '../components/enter-serial-number/ScanQRCodeButton.vue';
import BaseForm from '@shared/components/BaseForm.vue';
import { normalizeSolshareSerialForSubmit } from '@/shared/utils/solshare-serial';
import { commissioningSerialNumberValidator } from '../utils/solshare-commissioning';
import { ref } from 'vue';
import type { RuleObject } from 'ant-design-vue/es/form';
import router from '@/router';

const formRef = ref();
const formData = ref({
  serialNumber: '',
});

const validationRules: Record<string, RuleObject[]> = {
  serialNumber: [
    {
      required: true,
      message: 'Serial number is required',
      trigger: ['blur', 'change'],
    },
    {
      validator: commissioningSerialNumberValidator,
      trigger: ['blur', 'change'],
    },
  ],
};

const handleSubmit = async () => {
  const serialNumber = normalizeSolshareSerialForSubmit(formData.value.serialNumber);
  router.push({
    name: 'SearchingSolshare',
    params: { serialNumber },
  });
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <template #title>Enter the serial number.</template>
    <div class="content">
      <BaseForm
        ref="formRef"
        :model="formData"
        :rules="validationRules"
        @finish="handleSubmit"
        class="serial-form"
        id="serial-form"
      >
        <a-form-item name="serialNumber">
          <a-input
            v-model:value="formData.serialNumber"
            placeholder="e.g. 1-1-1234-1"
            size="large"
            data-tn="enter-serial-input"
          />
        </a-form-item>
      </BaseForm>
    </div>

    <div class="end-of-page">
      <ButtonPrimary
        html-type="submit"
        form="serial-form"
        class="submit-button"
        block
        data-tn="enter-serial-submit"
      >
        Submit
      </ButtonPrimary>
      <ScanQRCodeButton />
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.serial-form {
  width: 100%;
}

.ant-input:hover,
.ant-input-affix-wrapper:hover {
  background-color: white;
}

.end-of-page {
  border-top: 1px solid @color-mid-tone;
  padding: @content-side-margin;
  background-color: white;
  flex-grow: 1;
}

.submit-button {
  margin-bottom: @margin-bottom-button;
}
</style>
